import React, { memo, useEffect } from 'react'

// components
import { useTheme, useMediaQuery, Grid } from '@mui/material'

// redux
import { connect } from 'react-redux'
import setRedirectUrl from '../../redux/actions/redirection/setRedirectUrl'
import Navbar from '../../components/Navbar'
import Footer from '../Home/components/Footer'
import Calificaciones from '../../components/AdminLocal/AdminLocalCalificaciones/AdminLocalCalificaciones'
import ModalCalificaciones from '../../components/AdminLocal/AdminLocalCalificaciones/ModalCalificaciones'
import { useAppStore } from '../../store/app-store'
import { useCalificaciones } from './calificaciones.hook'
import { useAnalytics } from '../../hooks/useAnalytics'
import { RolType } from '../../components/Navbar/Sidebar/SidebarItems'

const CalificacionesVendedor: React.FC = (props: any) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const codLocal = useAppStore((store) => store.codLocal)
  const { calificacionesList, calificacionXatributoList, fetchData } = useCalificaciones(codLocal)
  const { track } = useAnalytics()
  const puedeEliminar = props.logged?.userLogged?.roles.includes(RolType.ADMIN || RolType.MOD)

  useEffect(() => {
    if (codLocal) track('vendor_calificaciones_ver', {})
  }, [codLocal])

  return (
    <>
      <Navbar title={`Mis Calificaciones`} />
      <Grid container direction={isMobile ? 'column' : 'row'} id="calificaciones-grid">
        <Grid item xs={12} md={6}>
          <Calificaciones
            codLocal={codLocal}
            isAdmin={false}
            calificacionXatributoList={calificacionXatributoList}
            calificacionesList={calificacionesList}
            fetchData={fetchData}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <ModalCalificaciones
            codLocal={codLocal}
            options={calificacionXatributoList}
            data={calificacionesList}
            isAdmin={false}
            puedeEliminar={puedeEliminar}
          />
        </Grid>
      </Grid>
      <Footer />
    </>
  )
}

const mapStateToProps = (state: any) => {
  return {
    logged: state.logged,
    theme: state.theme,
    toaster: state.toaster,
    redirection: state.redirection
  }
}

const mapDispatchToProps = {
  // resetToaster,
  setRedirectUrl
}

export default connect(mapStateToProps, mapDispatchToProps)(memo(CalificacionesVendedor))
